import { Link } from "react-router-dom";

const exploreLinks = [
  { label: "Fights", path: "/fights" },
  { label: "Players", path: "/players" },
  { label: "Teams", path: "/teams" },
  { label: "Leagues", path: "/leagues" },
  { label: "Games", path: "/games" },
];

export const ExploreSection = () => {
  return (
    <div>
      <h2 className="font-heading text-lg font-bold uppercase tracking-wider text-white mb-3">Explore the Database</h2>
      <div className="flex flex-wrap gap-3">
        {exploreLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className="bg-flyers-charcoal hover:bg-flyers-dark-gray text-white font-heading font-bold uppercase tracking-wider py-2 px-6 rounded border border-flyers-dark-gray hover:border-flyers-orange transition-all duration-150"
          >
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  );
};
